import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ArrowUpIcon = createIcon({
  displayName: 'ArrowUpIcon',
  path: [
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M17.25 10.25L12 4.75L6.75 10.25'
    />,
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M12 19.25V5.75'
    />
  ],
  defaultProps: defaultProps
})
